import AddFAQ from './Add.jsx';
import EditFAQ from './Edit.jsx';
import ListFAQs from './List.jsx';

export {AddFAQ, EditFAQ, ListFAQs};



// WEBPACK FOOTER //
// ./pages/faqs/index.js